import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { TrashIcon } from "@heroicons/react/24/outline";

function WhitelistedDomainsTable(props) {
  const { domainIdentifiers, onDelete } = props;

  return (
    <Table>
      <TableBody>
        {domainIdentifiers?.map((item, index) => {
          return (
            <TableRow key={index}>
              <TableCell>
                <p className="text-sm">{item}</p>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

export default WhitelistedDomainsTable;
